import {PageGenqlSelection} from "@/gql/gen";

export const PageFields: PageGenqlSelection = {
    "ID": true,
    "NAME": true,
    "CODE": true,
    "SORT": true,
    "URL": true,
    "DETAIL_PICTURE": {
        "__fragment": "Image"
    },
    "DETAIL_TEXT": true,
    "IBLOCK_CODE": true,
    "IBLOCK_ID": true,
    "PREVIEW_PICTURE": {
        "__fragment": "Image"
    },
    "META": {
        "__fragment": "ElementMeta"
    },
    "PREVIEW_TEXT": true,
    "PROPERTIES": {
        "META_DESCRIPTION": true,
        "META_KEYWORDS": true,
        "META_TITLE": true,
        "TPL_PAGE_CONTENT": true,
        "TPL_PAGE_VIEW": true
    },
    CONTENT_CHUNKS: {
        "__fragment": "PageContentChunk"
    }
}
